module.exports = __webpack_public_path__ + "static/img/banner.d41fc5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/banner.png
// module id = JiZl
// module chunks = 1